import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { GlobalService } from '../global.service';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';

@Component({
  selector: 'app-bank-transaction-excel2-acomponent',
  templateUrl: './bank-transaction-excel2-acomponent.component.html',
  styleUrls: ['./bank-transaction-excel2-acomponent.component.scss']
})
export class BankTransactionExcel2AComponentComponent implements OnInit {

  document_file: any = null;
    from_date: any;
    to_date: any;
    is_document_available: boolean = true;
    excel_report_data_list: any;
    color: ThemePalette = 'primary';
    mode: ProgressSpinnerMode = 'indeterminate';
    title: any;
  
    customer_type_list:any;
    selected_customer_type: any;
  
    constructor(private httpService: HttpService, private global: GlobalService) { 
      this.title = this.global._active_display_name;
      this.httpService.serveCustomerTypes().subscribe((data)=>{
        this.customer_type_list = data['customer_type_list'];
      }, (error) => {
        console.log(error);
      })
    }
  
    ngOnInit() {
    }
  
    changeEvent() {
      this.document_file = null;
    }
  
    getClicked() {
      let data_dict = {
        'from_date': this.from_date,
        'to_date': this.to_date,
        'customer_type': this.selected_customer_type
      };
      console.log(data_dict);
      this.is_document_available = false;
      this.httpService.bankTransactionExcel2a(data_dict).subscribe((data) => {
        if(data['is_report'] == true) {
          alert(data['report'])
          this.document_file = null;
          this.is_document_available = true;
        }
        else{
          console.log(data);
          this.excel_report_data_list = data['report_dict']
          this.document_file = data;
          this.is_document_available = true;
        }
      }, (error) => {
        this.is_document_available = true;
      });
    }
  
    downloadClicked() {
      const linkSource = 'data:application/excel;base64,' + this.document_file['excel'];
      const downloadLink = document.createElement("a");
      const fileName = this.document_file['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  
}
